import { render, staticRenderFns } from "./App.vue?vue&type=template&id=e5830412&scoped=true"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=e5830412&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5830412",
  null
  
)

export default component.exports